
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://htrngnxwhoepewidzckg.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh0cm5nbnh3aG9lcGV3aWR6Y2tnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQxMTQxMzMsImV4cCI6MjA3OTY5MDEzM30.3wX2neAS_CjDu0QKA6gNJ-q_eaQgBgNxqF-zexWEIYk'

export const supabase = createClient(supabaseUrl, supabaseKey)